// extracted by mini-css-extract-plugin
export default {"container":"Messages_container__oSpo7","noContent":"Messages_noContent__g9Myl"};